<template>
  <div class="card atc-journey mb-2">
    <div class="card-content">
      <div class="columns mb-0">
        <div class="column"></div>
        <div class="column is-narrow">
          <b-switch
            v-model="journey.requestCode"
            :rounded="false"
            :left-label="true"
            true-value="K"
            false-value="C"
            size="is-small"
            type="is-success"
          >
            Keep {{ journey.stops[0] }} 🠢
            {{ journey.stops[journey.stops.length - 1] }}
          </b-switch>
        </div>
      </div>

      <hr style="margin-top: 0.5em;margin-bottom: 0.5em;height: 1px" />

      <div class="columns">
        <div class="column">
          <div class="columns is-mobile">
            <div class="column is-narrow">
              <img
                class="airline_logo is-block"
                :src="$helpers.airlineLogo(airline, 30, 30)"
              />
              <h5
                class="has-text-grey has-text-weight-normal"
                style="font-size: 0.8rem"
              >
                {{ $helpers.getAirlineName(airline) }}
              </h5>
              <div class="has-text-grey" style="font-size: 0.8rem">
                {{ displayDate }}
              </div>
            </div>
          </div>
        </div>

        <div class="column is-narrow">
          <div class="columns is-mobile mb-0 mt-3">
            <div class="column">
              <b-tooltip
                class="is-size-6 has-text-weight-bold has-text-info is-clickable column"
                :label="$helpers.getAirportLocation(journey.stops[0])"
              >
                {{ journey.stops[0] }}
              </b-tooltip>
            </div>

            <div class="column">
              <div class="is-size-7 has-text-centered column">
                <b-icon
                  icon="airplane"
                  class="has-text-grey"
                  custom-class="mdi-rotate-45"
                ></b-icon>
              </div>
            </div>

            <div class="column">
              <b-tooltip
                class="is-size-6 has-text-weight-bold has-text-info is-clickable column"
                :label="
                  $helpers.getAirportLocation(
                    journey.stops[journey.stops.length - 1]
                  )
                "
              >
                {{ journey.stops[journey.stops.length - 1] }}
              </b-tooltip>
            </div>
          </div>

          <div
            v-if="journey.stops.length > 2"
            class="has-text-centered is-size-7 is-italic	"
          >
            via
            <span
              v-for="(stop, index) in journey.stops.slice(
                1,
                journey.stops.length - 1
              )"
              :key="index"
            >
              {{ stop }}{{ journey.stops.length - 3 > index ? ", " : "" }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "AtcJourney",
  components: {},
  props: {
    journey: {
      required: true,
      type: Object,
    },
    /*segments: {
      required: true,
      type: Array,
    }, */
  },
  data() {
    return {
      //requestCode: "C",
    };
  },
  methods: {
    getDiff(start, end) {
      return moment(start).diff(moment(end), "days");
    },
  },
  computed: {
    airline() {
      return this.journey.segments[0].airline;
    },
    segments() {
      return this.journey.segments;
    },
    displayDate() {
      return moment(this.dateString).format("MMMM DD, YYYY h:mm a");
    },
    dateString() {
      return (
        this.segments[0].startDate.date + " " + this.segments[0].startDate.time
      );
    },
  },
};
</script>

<style scoped>
.atc-journey {
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.02);
}
.column {
  padding: 0.25rem 0.5rem 0.25rem 0.5rem;
}
.columns {
  margin-top: -0.25rem;
  margin-right: -0.5rem;
  margin-left: -0.5rem;
}
.card-content {
  padding-left: 1rem;
  padding-right: 0.5rem;
  padding-bottom: 1.5rem;
  padding-top: 0.5rem;
}
</style>
